<form autocomplete="one-time-code" class="sr-only">
  <input type="text" inputmode="numeric" name="otp" autocomplete="one-time-code" (input)="handleAutofill($event)" style="position: absolute; opacity: 0" />
</form>

<div class="flex items-center justify-center space-x-2 md:space-x-4">
  @for (value of pinValues(); track $index) {
    <input
      #pinInput
      name="digit-{{ $index }}"
      id="digit-{{ $index }}"
      type="text"
      maxlength="1"
      inputmode="numeric"
      autocomplete="off"
      [value]="value"
      [disabled]="disabled()"
      (paste)="onPaste($event)"
      (input)="onInput($event, $index)"
      (keydown)="onKeyDown($event, $index)"
      style="appearance: textfield"
      class="center w-full min-w-8 overflow-hidden rounded-lg py-4 text-center ring-1 ring-neutral-40 placeholder:text-neutral-80 focus:ring-8 focus:ring-secondary-20"
      [ngClass]="{
        'ring-negative-100': isInvalid($index),
        'color-neutral-40 border-neutral-40 bg-neutral-5 text-neutral-40': disabled(),
      }"
      required />
  }
</div>
